import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { getImage } from '@utils/imageHelper';
import CheckCircleFilled from '@icon/CheckCircleFilled';
import { breakpoints } from '@styles/index';

const ImageContainer = styled.div`
  position: relative;
  grid-column: span 24;
  text-align: center;
`;

const ShadowPulse = keyframes`
  0% { box-shadow: ${boxShadowGenerator({
    yOffset: 0,
    blur: 0,
    color: 'rgba(8, 189, 128, 0.4)'
  })}; }
  70% { box-shadow: ${boxShadowGenerator({
    yOffset: 0,
    blur: 0,
    spread: '10px',
    color: 'rgba(8, 189, 128, 0)'
  })}; }
  100% {
    box-shadow: none;
  }
`;

const ConfettiImg = styled.img`
  user-select: none;
  user-drag: none;
  max-width: 360px;
  height: 160px;
  object-fit: cover;
  object-position: center 35%;
  width: 100%;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    height: 44.44vh;
    width: 100%;
    max-height: 160px;
  }
`;

const PulsatingGreenTick = styled(CheckCircleFilled)`
  animation: ${ShadowPulse} 2s infinite;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export default function Confetti() {
  return (
    <ImageContainer>
      <ConfettiImg
        alt="confetti"
        src={getImage('unlockplan/light-mode-confetti.gif')}
      />
      <PulsatingGreenTick
        size="65px"
        color="var(--color-i-green)"
        viewBox="4 4 16 16"
      />
    </ImageContainer>
  );
}
